<!--
  Loading indicator for lists paginated by the infiniteScrollObserver mixin.

  Markup and CSS are a verbatim port of vue-infinite-loading's spinners
  (node_modules/vue-infinite-loading/src/components/Spinner.vue plus
  src/styles/spinner.less and src/styles/wave-dots.less), so lists keep the exact
  indicator they showed before that dependency was dropped. `bubbles`/`circles`
  were never used in this app and are not ported.
-->
<template>
  <div class="scroll-loader">
    <span v-if="type === 'text'">Loading...</span>
    <i v-else-if="type === 'spiral'" class="loading-spiral" />
    <span v-else-if="type === 'waveDots'" class="loading-wave-dots">
      <span class="wave-item" />
      <span class="wave-item" />
      <span class="wave-item" />
      <span class="wave-item" />
      <span class="wave-item" />
    </span>
    <i v-else class="loading-default" />
  </div>
</template>

<script>
export default {
  name: 'ScrollLoader',
  props: {
    type: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'spiral', 'waveDots', 'text'].includes(value),
    },
  },
};
</script>

<style scoped>
/* from InfiniteLoading.vue's .infinite-loading-container */
.scroll-loader {
  clear: both;
  text-align: center;
}
.loading-default,
.loading-spiral,
.loading-wave-dots {
  display: inline-block;
  margin: 5px 0;
  width: 28px;
  height: 28px;
  font-size: 28px;
  line-height: 28px;
  border-radius: 50%;
}

.loading-default {
  position: relative;
  border: 1px solid #999;
  animation: loading-rotating ease 1.5s infinite;
}
.loading-default:before {
  content: '';
  position: absolute;
  display: block;
  top: 0;
  left: 50%;
  margin-top: -3px;
  margin-left: -3px;
  width: 6px;
  height: 6px;
  background-color: #999;
  border-radius: 50%;
}

.loading-spiral {
  border: 2px solid #777;
  border-right-color: transparent;
  animation: loading-rotating linear 0.85s infinite;
}

@keyframes loading-rotating {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-wave-dots {
  position: relative;
}
.loading-wave-dots .wave-item {
  position: absolute;
  top: 50%;
  left: 50%;
  display: inline-block;
  margin-top: -4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: loading-wave-dots linear 2.8s infinite;
}
.loading-wave-dots .wave-item:first-child {
  margin-left: -36px;
}
.loading-wave-dots .wave-item:nth-child(2) {
  margin-left: -20px;
  animation-delay: 0.14s;
}
.loading-wave-dots .wave-item:nth-child(3) {
  margin-left: -4px;
  animation-delay: 0.28s;
}
.loading-wave-dots .wave-item:nth-child(4) {
  margin-left: 12px;
  animation-delay: 0.42s;
}
.loading-wave-dots .wave-item:last-child {
  margin-left: 28px;
  animation-delay: 0.56s;
}

/* Flattened out of the .loading-wave-dots block: nested @keyframes never
   register, so the animation would silently not run. */
@keyframes loading-wave-dots {
  0% {
    transform: translateY(0);
    background: #bbb;
  }
  10% {
    transform: translateY(-6px);
    background: #999;
  }
  20% {
    transform: translateY(0);
    background: #bbb;
  }
  100% {
    transform: translateY(0);
    background: #bbb;
  }
}
</style>
